"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfGlobalToggleDto = instanceOfGlobalToggleDto;
exports.GlobalToggleDtoFromJSON = GlobalToggleDtoFromJSON;
exports.GlobalToggleDtoFromJSONTyped = GlobalToggleDtoFromJSONTyped;
exports.GlobalToggleDtoToJSON = GlobalToggleDtoToJSON;
exports.GlobalToggleDtoToJSONTyped = GlobalToggleDtoToJSONTyped;
/**
 * Check if a given object implements the GlobalToggleDto interface.
 */
function instanceOfGlobalToggleDto(value) {
    if (!('isEnabled' in value) || value['isEnabled'] === undefined)
        return false;
    return true;
}
function GlobalToggleDtoFromJSON(json) {
    return GlobalToggleDtoFromJSONTyped(json, false);
}
function GlobalToggleDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'isEnabled': json['isEnabled'],
    };
}
function GlobalToggleDtoToJSON(json) {
    return GlobalToggleDtoToJSONTyped(json, false);
}
function GlobalToggleDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'isEnabled': value['isEnabled'],
    };
}
